import React, { useRef, useState } from "react";
import Text from "../../../common/typography/text";
import TextInput from "../../../common/text-input";
import DropdownComponent from "../../../common/dropdown-input";
import { Input } from "antd";
import "../DirectOrder.css";
import { colors } from "../../../theme/colors";
import DatePickerComponent from "../../../common/date-picker";
import dayjs from "dayjs";
import NewProviderModal from "./NewProviderModal";

const ProcedureContent = ({
  accountID,
  providerName,
  setProviderName,
  providerOptions,
  isLoadingProviderOptions,
  onProviderCreated,
  applicationDate,
  handleApplicationDate,
  firstNameInitials,
  setFirstNameInitials,
  lastNameInitials,
  setLastNameInitials,
  applicationNumber,
  setApplicationNumber,
}) => {
  const lastOtpRef = useRef(null);
  const firstOtpRef = useRef(null);
  const [isNewProviderModalOpen, setIsNewProviderModalOpen] = useState(false);

  const handleFirstInitialsChange = (text) => {
    const lettersOnly = text.replace(/[^a-zA-Z]/g, "").toUpperCase();
    setFirstNameInitials(lettersOnly);

    if (lettersOnly.length === 3) {
      lastOtpRef.current?.focus?.();
    }
  };

  const handleLastInitialsChange = (text) => {
    const lettersOnly = text.replace(/[^a-zA-Z]/g, "").toUpperCase();
    setLastNameInitials(lettersOnly);
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  return (
    <>
      <Text variant="h1">Add Procedure Details</Text>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        <div className="field-group-wrapper">
          <div className="field-group provider-field-group">
            <DropdownComponent
              label="Provider's Name"
              placeholder={
                !accountID
                  ? "Select Account first"
                  : isLoadingProviderOptions
                    ? "Loading providers..."
                    : providerOptions?.length > 0
                      ? "Select Provider"
                      : "No providers found"
              }
              options={providerOptions}
              value={providerName}
              setValue={setProviderName}
              parentClassname="full-width-button"
              isDisabled={
                !accountID ||
                isLoadingProviderOptions ||
                (providerOptions?.length ?? 0) === 0
              }
            />
            <button
              type="button"
              className="add-new-provider-button"
              disabled={!accountID}
              onClick={() => setIsNewProviderModalOpen(true)}
              title={!accountID ? "Select an account before adding a provider." : undefined}
            >
              + Add New Provider
            </button>
          </div>
        </div>
        <div className="field-group-wrapper">
          <div className="field-group">
            <div className="initials-row">
              <div className="initials-column">
                <Text variant="tinyText">Patient First Name Initials</Text>
                <Input.OTP
                  ref={firstOtpRef}
                  length={3}
                  value={firstNameInitials}
                  onChange={(v) => handleFirstInitialsChange(v)}
                  formatter={(str) => str.toUpperCase()}
                  inputMode="text"
                />
              </div>
              <div className="initials-column">
                <Text variant="tinyText">Patient Last Name Initials</Text>
                <Input.OTP
                  length={3}
                  value={lastNameInitials}
                  onChange={(v) => handleLastInitialsChange(v)}
                  formatter={(str) => str.toUpperCase()}
                  inputMode="text"
                  ref={lastOtpRef}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="field-group-wrapper">
          <div className="field-group">
            <DatePickerComponent
              format="MM-DD-YYYY"
              placeholder="Select Date"
              titleText="Application Date"
              disabledDate={disabledDate}
              value={applicationDate}
              onChange={handleApplicationDate}
              parentClassName="full-width-button"
            />
          </div>
        </div>
        <div className="field-group-wrapper">
          <div className="field-group">
            <TextInput
              titleText="Application Number"
              placeholder="Enter Application Number"
              parentClassName="full-width-button"
              value={applicationNumber}
              setValue={setApplicationNumber}
            />
          </div>
        </div>
      </div>
      <NewProviderModal
        isOpen={isNewProviderModalOpen}
        onClose={() => setIsNewProviderModalOpen(false)}
        accountID={accountID}
        onProviderCreated={onProviderCreated}
      />
    </>
  );
};

export default ProcedureContent;
